<template>
  <div class="footer-bottom-text__wrapper text-small">
    <p class="footer-bottom-text__section">
      <span class="footer-bottom-text__section-name bold">
        {{ HIGH_RISK_WARNING_TITLE }}
      </span>
      <span class="footer-bottom-text__section-text">
        {{ HIGH_RISK_WARNING_TEXT }}
      </span>
    </p>
    <p class="footer-bottom-text__section">
      <span class="footer-bottom-text__section-name bold">
        {{ ADVISORY_WARNING_TITLE }}
      </span>
      <span class="footer-bottom-text__section-text">
        {{ ADVISORY_WARNING_TEXT }}
      </span>
    </p>
    <p class="footer-bottom-text__section">
      <span class="footer-bottom-text__section-name bold">
        {{ DISCLAIMER_TITLE }}
      </span>
      <span class="footer-bottom-text__section-text">
        {{ DISCLAIMER_TEXT }}
      </span>
    </p>
    <div class="footer-horizontal-divider"></div>
    <div class="footer-bottom-text__info">
      <p>
        <span>
          {{ BILLING_ADDRESS }}
        </span>
        <a-link
          class="footer-bottom-text__section-link"
          :to="ULTIMATE_GROUP_LINK"
        >
          Ultimate Group
        </a-link>
      </p>
      <p class="text-small">
        Read our
        <a-link class="footer-bottom-text__section-link" :to="linkToTerms"
          >Terms</a-link
        >,
        <a-link class="footer-bottom-text__section-link" :to="linkToCookies"
          >Cookies</a-link
        >
        and
        <a-link class="footer-bottom-text__section-link" :to="linkToPrivacy"
          >Privacy Notice</a-link
        >
      </p>
      <footer-manage-cookies />
    </div>
  </div>
</template>

<script>
import {
  HIGH_RISK_WARNING_TITLE,
  HIGH_RISK_WARNING_TEXT,
  ADVISORY_WARNING_TITLE,
  ADVISORY_WARNING_TEXT,
  DISCLAIMER_TITLE,
  DISCLAIMER_TEXT,
  BILLING_ADDRESS,
  ULTIMATE_GROUP_LINK
} from '@/utils/enums/footer'
import FooterManageCookies from '@/components/AFooter/FooterBottomText/FooterManageCookies'
import { ROUTE_NAME } from 'enums/routes'

export default {
  name: 'FooterBottomText',
  components: { FooterManageCookies },
  data() {
    return {
      HIGH_RISK_WARNING_TITLE,
      HIGH_RISK_WARNING_TEXT,
      ADVISORY_WARNING_TITLE,
      ADVISORY_WARNING_TEXT,
      DISCLAIMER_TITLE,
      DISCLAIMER_TEXT,
      BILLING_ADDRESS,
      ULTIMATE_GROUP_LINK,
      linkToTerms: {
        name: ROUTE_NAME.TERMS_OF_USE
      },
      linkToPrivacy: {
        name: ROUTE_NAME.PRIVACY
      },
      linkToCookies: {
        name: ROUTE_NAME.COOKIES
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-bottom-text__wrapper {
  .footer-bottom-text__section {
    margin-bottom: 20px;
    color: $c--gray-light;

    &:last-child {
      margin-bottom: 0;
    }

    @include mobile {
      line-height: 15px;
    }
  }

  .footer-bottom-text__section-name {
    color: $c--white;
  }

  .footer-bottom-text__info {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    color: $c--white;
    font-weight: 500;

    @include tablet {
      flex-direction: row;

      :nth-child(1) {
        width: 100%;
        margin-bottom: 55px;
      }

      :nth-child(2),
      :nth-child(3) {
        width: auto;
      }
    }

    @include mobile {
      flex-direction: column;

      & > *:not(:last-child) {
        margin-bottom: 12px;
      }
    }

    .footer-bottom-text__section-link {
      color: $c--main;
    }
  }
}
</style>
